export const misnpBaseURL = 'https://misnp.amdocs.com';
export const misBaseURL = 'https://mis.amdocs.com';
export const serviceNowUrl = 'https://amdocsuat.service-now.com';
export const serviceNowProdUrl = 'https://amdocsprodmain.service-now.com';

export const baseEnvironment = {
  serviceNowBaseUrl: serviceNowUrl,
  loginGWBaseURL: '',
  graphQlBaseURL: '/graphql',
  cnsBaseURL: '',
  avatarsVersion: '1',
  refreshTokenInterval: 3000000, // 50 minutes
  pushPublicKey:
    'BBjDHF8cFoJznds83RrbZByg-UQCxWTNb9afVNjxjbpIsj2CaJyKDrndm9GwHk9Tbargfzt83gYprv9kl1OvIEU',
  startChatURL: `${serviceNowUrl}/ta?id=ta_it_chat&origin=clic`,
  serviceNowURL: `${serviceNowUrl}/ta?origin=clic`,
  reportAnIssueUrl: `${serviceNowUrl}/ta?id=ta_sc_cat_item&sys_id=e444b00cdb4b6090a258e1aa4b9619a8&origin=clic`,
  faqURL: `${serviceNowProdUrl}/ta?id=aop_kb_article_page_try_it&sys_id=6b56035487a7f450544d2fc8cebb3522&origin=clic`,
  appId: 'clic-2',
  LEARNING_PORTAL: 'https://learning-dev.misnp.amdocs.com',
  activitiesInitialData: [],
  authenticationEnabled: true,
  bot: {
    id: 'mis-Navigator-Dev',
    name: 'mis-Navigator-Dev',
  },
  showToastTime: Infinity,
  supportTicketLink:
    'https://amdocsprodmain.service-now.com/ta?id=ta_sc_cat_item&sys_id=ae4196b387270a544f7762480cbb357b',
  enableTypingCursor: true,
  apiKey: '',
  apiUrl: '',
  ta_link_hr4u_cat_sys_id: '1f9508088746f010641e98683cbb3531',
  ta_link_amdocs_one_portal_cat_sys_id: 'c658fa6e0fee9340493bbb8ce1050e13',
  default_ta_link: 'https://amdocsprodmain.service-now.com/ta',
  generateAPI: {
    retryCount: 2,
    retryDelay: 1000,
  },
  isMockBot: false,
  enableLogging: true,
  chatHistoryData: {
    operationType: 'GET_CONVERSATION_HISTORY',
    botConversatonId: 'eu-4343456789',
    messageSize: 20,
    pageNumber: 1,
    continuationToken: '',
    hasMore: true,
    messages: [
      {
        messageId: 'msg010',
        type: 'message',
        id: 'lO2nTqf5SCC6cmyMYlv2u-eu|0000017',
        timestamp: '2026-01-27T15:34:44.8399471Z',
        from: {
          id: 'user',
          role: 'user',
        },
        text: 'Sure! Can you share your order number?',
        attachments: [],
        channelData: {
          sourceType: 'genai',
          type: 'sourceArticle',
          data: [
            {
              urlTitle: 'ESPP at a glance',
              urlLink:
                'https://amdocsprodmain.service-now.com/one_portal?id=aop_kb_article_page&sys_id=48c5d08e87e161106fd564e09bbb356d',
              isRelevant: false,
            },
            {
              urlTitle: 'How to enroll to ESPP?',
              urlLink:
                'https://amdocsprodmain.service-now.com/one_portal?id=aop_kb_article_page&sys_id=32a055068761a1106fd564e09bbb35e9',
              isRelevant: true,
            },
          ],
        },
      },
      {
        messageId: 'msg011',
        type: 'message',
        id: 'lO2nTqf5SCC6cmyMYlv2u-eu|0000018',
        timestamp: '2026-01-27T15:34:44.8399471Z',
        from: {
          id: 'mis-Navigator-Dev',
          name: 'mis-Navigator-Dev',
        },
        text: 'Sure! Can you share your order number?',
        attachments: [],
        channelData: {
          sourceType: 'genai',
          type: 'sourceArticle',
          data: [
            {
              urlTitle: 'ESPP at a glance',
              urlLink:
                'https://amdocsprodmain.service-now.com/one_portal?id=aop_kb_article_page&sys_id=48c5d08e87e161106fd564e09bbb356d',
              isRelevant: false,
            },
            {
              urlTitle: 'How to enroll to ESPP?',
              urlLink:
                'https://amdocsprodmain.service-now.com/one_portal?id=aop_kb_article_page&sys_id=32a055068761a1106fd564e09bbb35e9',
              isRelevant: true,
            },
          ],
        },
      },
    ],
  },
  chatHistoryList: {
    operationType: 'LIST_CONVERSATIONS ',
    pageSize: 20,
    pageNumber: 1,
    continuationToken: '',
    hasMore: true,
    conversations: [
      {
        botConversationId: '1234567890',
        updatedAt: '2026-01-02T09:00:00Z',
        title: 'Sure! Can you share your order number?',
      },
      {
        botConversationId: 'eu-456789',
        updatedAt: '2026-01-08T14:15:00Z',
        title: 'How to submit guest reservation?',
      },
    ],
  },
};
